module.exports = __webpack_public_path__ + "media/images/icons/country_flags/us-912cb4a8f30b24032f0dbf258d674ae9.svg";